export default {
  title: "Рӯйхати муштариён",
  allClients: "Ҳамаи муштариён",
  internalClients: "Дохилӣ",
  internalClient: "Дохилӣ",
  externalClients: "Хориҷӣ",
  externalClient: "Хориҷӣ",
  clientsType: "Навъи муштарӣ",

  noEnitity: {
    label: "Саҳифа дастрас нест",
    text: "Шахси ҳуқуқии шумо дар модератсия аст",
  },
  needBuyTariff: "Барои рақамӣ кардани муштариён зарур аст тариф харед",
  noTradingPoint: "То ҳол шумо нуқати тиҷоратӣ надоред",
  digitizeClients:
    "Муштариёнро рақамӣ кунед, то онҳо дар рӯйхати шумо намоиш дода шаванд",

  table: {
    inviteDate: "Санаи бақайдгирӣ",
    fullName: "Ному насаб",
    phone: "Рақами телефон",
    receiptsCount: "Миқдори харидҳо",
    receiptsSum: "Суммаи харидҳо",
  },

  clientCard: {
    title: "Маълумот дар бораи муштарӣ",
    client: {
      title: "Муштарӣ",
      fields: {
        fullName: "Ному насаб",
        gender: "Ҷинс",
        birthDate: "Санаи таваллуд",
        phone: "Рақами телефон",
        clientType: "Навъи муштарӣ",
        inviteDate: "Санаи бақайдгирӣ",
        regSource: "Манбаи бақайдгирӣ",
        rcCard: "Рақами корти RC",
        note: "Қайд",
      },
      phoneHint:
        "Рақами телефон фақат дар тарифҳои пулакӣ ва фақат барои муштариёне намоиш дода мешавад, ки розӣ будаанд ба интиқоли маълумоти тамос ва гирифтани пешниҳодҳои маркетингӣ.",
    },
    statistic: {
      title: "Омор",
      block: {
        avgReceiptsSum: "Миёнаи чек",
        receiptsCount: "Миқдори харидҳо",
        receiptsSum: "Даврамал",
        writeOffPointsSum: "Пардохт бо баллҳо",
      },
      totalNumberOfVisit: "Миқдори умумии ташрифҳо",
      firstVisit: "Нахустин ташриф",
      lastVisit: "Охирин ташриф",
      visitedShops: "Муассисаҳои ташрифкардашуда",
    },
    receipts: {
      title: "Чекҳо",
      emptyState: {
        title: "Чекҳо нестанд",
        description:
          "Онҳо пас аз анҷом додани хариди муштарӣ дар ин ҷо пайдо мешаванд",
      },
    },
    reviews: {
      title: "Аксуламотҳо",
      noReviews: "То ҳол аксуламот нестанд",
      itsAppearHere:
        "Онҳо пас аз додани аксуламот аз ҷониби муштарӣ дар ин ҷо пайдо мешаванд",
    },
  },
  pointsAwarded: "Баллҳо ҳисобшуда",
  digitizingOnYourTariffNotAvailable:
    "Рақамӣ кардани муштариён дар тарифи шумо дастрас нест",
  digitizingIntoRC: "Рақамӣ кардани муштариён<br> тавассути RC PAY",
  fastDigitizingIntoTg: "Рақамсозии суръатёфта<br> тавассути Telegram-бот",
  abilityToUseLinkOrQRcode:
    "Имконияти истифодаи пайванд ё QR-рамз барои таклиф кардани корбарони нав пас аз харидани тариф дастрас мешавад.",
  inviteClients: "Таклиф кардани муштариён",
  selectPointToGenerateQR:
    "Нуқати тиҷоратиро интихоб кунед, то пайванд ва QR-рамз барои бақайдгирии муштариёни нав дар RC PAY эҷод кунед.",
  invitingtoLoyaltyProgram: "Таклиф ба барномаи вафодорӣ",
  downloadQR: "Боргирии QR-рамз",
  linkCopied: "Пайванд нусхабардорӣ шуд",
  share: "Мубодила кардан",
  joinToLoyaltyProgram: "Ба барномаи вафодорӣ ҳамроҳ шав!",
  receiveDiscountNotifies:
    "Огоҳиномаҳо дар бораи тахфифҳо ва аксияҳои истисноӣ гиред. Дар мо ҳар як харид мукофот дорад ва пардохт бо баллҳо то 99.9%.",
  clientServiceAndAppRcPay:
    "Хизмати муштарии rcpay.ru ва барномаи RC PAY — роҳнамоёни шумо дар ҷаҳони хариди арзон ва рӯҳат!",
};
